import React from 'react';
import { THEMES, loadProgress, themeProgressPct, PASS } from '../data/learning';
import { ComparePanel } from '../components/ui/learnbits';

export const Voortgang: React.FC = () => {
  const store = loadProgress();
  const pcts = THEMES.map((t) => themeProgressPct(t.id));
  const totaal = Math.round(pcts.reduce((p, c) => p + c, 0) / THEMES.length);
  const afgerond = pcts.filter((p) => p >= 100).length;
  const onderdelen = THEMES.reduce((p, t) => p + store[t.id].doneModules, 0);
  const certs = THEMES.filter((t) => themeProgressPct(t.id) >= 100 && (store[t.id].toets ?? 0) >= PASS).length;

  const kpis = [
    { label: 'Totale voortgang', value: `${totaal}%` },
    { label: 'Thema’s afgerond', value: String(afgerond) },
    { label: 'Onderdelen voltooid', value: String(onderdelen) },
    { label: 'Certificaten', value: String(certs) },
  ];

  return (
    <div className="shell py-12 sm:py-16">
      <h1 className="font-display font-bold text-ink mb-2" style={{ fontSize: 'clamp(30px,4.5vw,44px)', letterSpacing: '-0.02em' }}>Mijn voortgang</h1>
      <p className="text-sub mb-8 max-w-readable">Een overzicht van waar je staat over alle thema’s heen — en hoe je eigen inschatting zich verhoudt tot je toetsresultaten.</p>

      <div className="grid gap-[18px] mb-8" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(160px,1fr))' }}>
        {kpis.map((k) => (
          <div key={k.label} className="card p-5">
            <p className="font-display font-bold text-ink" style={{ fontSize: 42, lineHeight: 1 }}>{k.value}</p>
            <p className="label mt-1">{k.label}</p>
          </div>
        ))}
      </div>

      <ComparePanel title="Inschatting vs. toets per thema" />
    </div>
  );
};
